module.exports = __webpack_public_path__ + "MarkerIcon.756a8c50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Logotypes/MarkerIcon.svg
// module id = aLQP
// module chunks = 1